import { toDateOrNull } from './pip-improvement-activity.model';

export class PipPlanFormApiModel {
  public Id: number;
  public FormName: string;
  public FormDate: Date | null;
  public CompletedBy: string;
  public CurrentStage: string;

  public deserialize(data: object): this {
    Object.assign(this, data);

    this.FormDate = toDateOrNull(this.FormDate);

    return this;
  }
}
